// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"bead5266","87":"38af5d79","99":"f6da1ef2","155":"b3ded77b","263":"f5271014","272":"7c3a37bd","336":"a0989d16","399":"df2c1660","534":"2c8f9587","631":"17e393fe","891":"6930f519"}[chunkId] + ".chunk.js";
};